import type { PropsWithChildren } from "react";
import { FormDatePicker } from "./date-picker/DatePicker";
import { FormPhone } from "./phone/FormPhone";
import { Phone } from "./phone/Phone";
import { FormSelect } from "./select/FormSelect";

type InputWrapperProps = PropsWithChildren & {
  label?: React.ReactNode;
  altLabel?: React.ReactNode;
  error?: React.ReactNode;
  noErrorIcon?: boolean;
};

type Props = {
  className?: string;
  bordered?: boolean;
  placeholder?: string;
  primary?: boolean;
  defaultValue?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  type?: "text" | "number";
  disabled?: boolean;
  noErrorIcon?: boolean;
  // Rest of props
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  [x: string]: any;
} & InputWrapperProps;

export const Input = {
  Phone,
  FormPhone,
  DatePicker: FormDatePicker,
  Select: FormSelect,
} as React.ForwardRefExoticComponent<Props> & {
  Phone: typeof Phone;
  FormPhone: typeof FormPhone;
  DatePicker: typeof FormDatePicker;
  Select: typeof FormSelect;
};
